import axios from 'axios';
import { useStore, store } from 'vuex';
import cookieService from '@/services/cookies';

let instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 100000,
  headers: {
    Authorization: store?.state?.token || ''
  }
});

instance.interceptors.request.use(
  function (config) {
    if (
      config.data &&
      Object.keys(config.data).length &&
      // allows explicitly overriding default to
      // form-encoding by caller
      config.headers['Content-Type'] !== 'application/json'
    ) {
      config.data = new URLSearchParams(config.data);
    }

    let token;

    try {
      token = cookieService.getIdentityToken();
    } catch (err) {
      console.error("error from the cookieService on the interceptor:", err);
    }

    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }

    return config;
  },
  function (error) {
    // Do something with request error
    console.error("Error with getting token: ", error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    // Avoid logging entire responses, which can freeze the UI for large payloads
    // Keep a lightweight debug log for request metadata when needed
    // if (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_DEBUG_HTTP === 'true') {
    //   try {
    //     const method = (response?.config?.method || 'get').toUpperCase();
    //     const url = response?.config?.url || '';
    //     const status = response?.status;
    //     let sizeHint = 'n/a';
    //     const d = response?.data;
    //     if (typeof d === 'string') sizeHint = `${d.length} chars`;
    //     else if (Array.isArray(d)) sizeHint = `${d.length} items`;
    //     else if (d && typeof d === 'object') sizeHint = `${Object.keys(d).length} keys`;
    //     // eslint-disable-next-line no-console
    //     console.debug(`[HTTP ${status}] ${method} ${url} (size: ${sizeHint})`);
    //   } catch (_e) {
    //     // noop
    //   }
    // }
    return response;
  },
  function (error) {
    // Keep error logs concise
    try {
      const method = (error?.config?.method || 'get').toUpperCase();
      const url = error?.config?.url || '';
      // eslint-disable-next-line no-console
      console.error(`[HTTP ERROR] ${method} ${url}:`, error?.message || error);
    } catch (_e) {
      // eslint-disable-next-line no-console
      console.error("interceptor response error: ", error);
    }
    return Promise.reject(error);
  }
);

export default instance;

// JFC
export const axiosInstance = instance;
